/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { fonts, colors } from '@blend/consumer-components';
import { mediaBreakpoints } from '../../../common/responsive';

export namespace AgentCardNameWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

const styles = StyleSheet.create({
  agentCardNameWrapper: {
    ...fonts.UntitledSans,
    display: 'block',
    fontSize: 18,
    fontWeight: fonts.weight.medium,
    color: colors.clayPlus4,
    margin: 0,
    [mediaBreakpoints.mobile]: {
      fontSize: 24,
    },
  },
});

export const AgentCardNameWrapper: React.FC<AgentCardNameWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <div className={css(styles.agentCardNameWrapper)} data-it="LoanAgentName" {...htmlProps}>
      {children}
    </div>
  );
};
